/* eslint-disable class-methods-use-this, sort-imports, sonarjs/no-collapsible-if, no-prototype-builtins, sonarjs/cognitive-complexity, func-style */
import { Tooltip } from 'bootstrap';
import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import zoomPlugin from 'chartjs-plugin-zoom';
import 'regenerator-runtime/runtime';
import CustomChoices from '../vendor/customChoices';

Chart.register(zoomPlugin);
Chart.register(ChartDataLabels);

// Function to check if a given string is a valid URL
function isValidURL(str) {
  try {
    new URL(str); // eslint-disable-line no-new

    return true;
  } catch (error) { // eslint-disable-line no-unused-vars
    return false;
  }
}

function hasNonEmptyCompiledNV12(items) {
  // Loop through each item in the "items" array
  for (const item of items) {
    // Check if "compiled_nv12" property exists and is not empty
    if (item.hasOwnProperty('compiled_nv12') && item.compiled_nv12 !== '') {
      // If found, return true
      return true;
    }
  }

  // If no non-empty "compiled_nv12" property found, return false
  return false;
}

function isFileURL(url) {
  // List of common file extensions
  const fileExtensions = [ '.jpg', '.jpeg', '.png', '.gif', '.pdf', '.doc', '.docx', '.txt', '.zip', '.hef' ];

  // Check if the URL ends with any of the file extensions
  return fileExtensions.some(extension => url.toLowerCase().endsWith(extension));
}

// Helper function to check if the mouse is over an element
const isMouseOverElement = (element, event) => {
  const rect = element.getBoundingClientRect();

  return (
    event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom
  );
};

const findTooltipByColumn = (columnKey, data) => {
  for (const element of data) {
    if (element.column === columnKey) {
      return element.tooltip;
    }
  }

  return null;
};

const iconLink = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <mask id="mask0_8772_5310" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect width="24" height="24" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_8772_5310)"> <path d="M10.8077 16.5378H7.03845C5.78282 16.5378 4.7125 16.0953 3.8275 15.2105C2.9425 14.3256 2.5 13.2554 2.5 11.9999C2.5 10.7444 2.9425 9.67406 3.8275 8.78881C4.7125 7.90356 5.78282 7.46094 7.03845 7.46094H10.8077V8.96089H7.03845C6.1987 8.96089 5.48235 9.25736 4.8894 9.85031C4.29645 10.4433 3.99998 11.1596 3.99998 11.9994C3.99998 12.8391 4.29645 13.5555 4.8894 14.1484C5.48235 14.7414 6.1987 15.0378 7.03845 15.0378H10.8077V16.5378ZM8.25 12.7493V11.2494H15.75V12.7493H8.25ZM13.1923 16.5378V15.0378H16.9615C17.8013 15.0378 18.5176 14.7414 19.1106 14.1484C19.7035 13.5555 20 12.8391 20 11.9994C20 11.1596 19.7035 10.4433 19.1106 9.85031C18.5176 9.25736 17.8013 8.96089 16.9615 8.96089H13.1923V7.46094H16.9615C18.2171 7.46094 19.2875 7.90338 20.1725 8.78826C21.0575 9.67315 21.5 10.7433 21.5 11.9988C21.5 13.2543 21.0575 14.3247 20.1725 15.2099C19.2875 16.0952 18.2171 16.5378 16.9615 16.5378H13.1923Z" fill="currentColor"/> </g> </svg>';
const iconDownload = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <mask id="mask0_10446_399" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect width="24" height="24" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_10446_399)"> <path d="M12 15.7884L7.7308 11.5193L8.78462 10.4347L11.25 12.9V4.5H12.7499V12.9L15.2153 10.4347L16.2692 11.5193L12 15.7884ZM6.3077 19.5C5.80257 19.5 5.375 19.325 5.025 18.975C4.675 18.625 4.5 18.1974 4.5 17.6923V14.9808H5.99997V17.6923C5.99997 17.7692 6.03202 17.8397 6.09612 17.9038C6.16024 17.9679 6.23077 18 6.3077 18H17.6922C17.7692 18 17.8397 17.9679 17.9038 17.9038C17.9679 17.8397 18 17.7692 18 17.6923V14.9808H19.5V17.6923C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6922 19.5H6.3077Z" fill="currentColor"/> </g> </svg>';
const iconDownloadNV12 = '<svg width="25" height="34" viewBox="0 0 25 34" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.5 11.7884L8.2308 7.51925L9.28462 6.43465L11.75 8.90003V0.5H13.2499V8.90003L15.7153 6.43465L16.7692 7.51925L12.5 11.7884ZM6.8077 15.5C6.30257 15.5 5.875 15.325 5.525 14.975C5.175 14.625 5 14.1974 5 13.6923V10.9808H6.49997V13.6923C6.49997 13.7692 6.53202 13.8397 6.59612 13.9038C6.66024 13.9679 6.73077 14 6.8077 14H18.1922C18.2692 14 18.3397 13.9679 18.4038 13.9038C18.4679 13.8397 18.5 13.7692 18.5 13.6923V10.9808H20V13.6923C20 14.1974 19.825 14.625 19.475 14.975C19.125 15.325 18.6974 15.5 18.1922 15.5H6.8077Z" fill="currentColor"/> <path d="M6.64773 24.2272V31.4999H5.79545L1.83239 25.7897H1.76136V31.4999H0.880682V24.2272H1.73295L5.71023 29.9516H5.78125V24.2272H6.64773ZM8.70827 24.2272L10.8674 30.3494H10.9526L13.1117 24.2272H14.035L11.3645 31.4999H10.4554L7.78498 24.2272H8.70827ZM17.5968 24.2272V31.4999H16.7161V25.1505H16.6735L14.8979 26.3295V25.4346L16.7161 24.2272H17.5968ZM19.6884 31.4999V30.8607L22.089 28.2329C22.3707 27.9251 22.6027 27.6576 22.785 27.4303C22.9673 27.2007 23.1022 26.9853 23.1898 26.784C23.2798 26.5804 23.3248 26.3674 23.3248 26.1448C23.3248 25.8891 23.2632 25.6678 23.1401 25.4808C23.0194 25.2937 22.8536 25.1493 22.6429 25.0475C22.4322 24.9457 22.1955 24.8948 21.9327 24.8948C21.6533 24.8948 21.4095 24.9528 21.2012 25.0688C20.9952 25.1825 20.8354 25.3423 20.7218 25.5482C20.6105 25.7542 20.5549 25.9957 20.5549 26.2727H19.7168C19.7168 25.8465 19.815 25.4725 20.0115 25.1505C20.208 24.8285 20.4756 24.5776 20.8141 24.3977C21.155 24.2177 21.5373 24.1278 21.9611 24.1278C22.3873 24.1278 22.7649 24.2177 23.0939 24.3977C23.423 24.5776 23.681 24.8203 23.8681 25.1256C24.0551 25.431 24.1486 25.7708 24.1486 26.1448C24.1486 26.4123 24.1001 26.6739 24.003 26.9296C23.9083 27.1829 23.7426 27.4658 23.5059 27.7783C23.2715 28.0885 22.946 28.4673 22.5293 28.9147L20.8958 30.6619V30.7187H24.2765V31.4999H19.6884Z" fill="currentColor"/> </svg>';
const iconDownloadRgb = '<svg width="21" height="34" viewBox="0 0 21 34" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M10.5 11.7884L6.2308 7.51925L7.28462 6.43465L9.75 8.90003V0.5H11.2499V8.90003L13.7153 6.43465L14.7692 7.51925L10.5 11.7884ZM4.8077 15.5C4.30257 15.5 3.875 15.325 3.525 14.975C3.175 14.625 3 14.1974 3 13.6923V10.9808H4.49997V13.6923C4.49997 13.7692 4.53202 13.8397 4.59612 13.9038C4.66024 13.9679 4.73077 14 4.8077 14H16.1922C16.2692 14 16.3397 13.9679 16.4038 13.9038C16.4679 13.8397 16.5 13.7692 16.5 13.6923V10.9808H18V13.6923C18 14.1974 17.825 14.625 17.475 14.975C17.125 15.325 16.6974 15.5 16.1922 15.5H4.8077Z" fill="currentColor"/> <path d="M0.880682 31.4999V24.2272H3.33807C3.90625 24.2272 4.37263 24.3243 4.73722 24.5184C5.1018 24.7102 5.37169 24.9741 5.54688 25.3103C5.72206 25.6465 5.80966 26.0288 5.80966 26.4573C5.80966 26.8858 5.72206 27.2658 5.54688 27.5972C5.37169 27.9287 5.10298 28.1891 4.74077 28.3785C4.37855 28.5655 3.91572 28.659 3.35227 28.659H1.36364V27.8636H3.32386C3.71212 27.8636 4.02462 27.8068 4.26136 27.6931C4.50047 27.5795 4.6733 27.4185 4.77983 27.2102C4.88873 26.9995 4.94318 26.7485 4.94318 26.4573C4.94318 26.1661 4.88873 25.9116 4.77983 25.6938C4.67093 25.476 4.49692 25.3079 4.25781 25.1896C4.0187 25.0688 3.70265 25.0085 3.30966 25.0085H1.76136V31.4999H0.880682ZM4.30398 28.2329L6.09375 31.4999H5.07102L3.30966 28.2329H4.30398ZM12.2488 26.4999C12.1706 26.2608 12.0676 26.0466 11.9398 25.8572C11.8143 25.6654 11.664 25.5021 11.4888 25.3671C11.316 25.2322 11.1195 25.1292 10.8993 25.0582C10.6792 24.9872 10.4377 24.9516 10.1749 24.9516C9.74402 24.9516 9.35221 25.0629 8.99947 25.2855C8.64672 25.508 8.36618 25.8359 8.15785 26.2691C7.94951 26.7024 7.84535 27.2338 7.84535 27.8636C7.84535 28.4933 7.9507 29.0248 8.1614 29.458C8.3721 29.8913 8.65737 30.2192 9.01722 30.4417C9.37707 30.6642 9.7819 30.7755 10.2317 30.7755C10.6484 30.7755 11.0153 30.6867 11.3326 30.5092C11.6522 30.3292 11.9007 30.0759 12.0783 29.7492C12.2582 29.4202 12.3482 29.0331 12.3482 28.588L12.6181 28.6448H10.4306V27.8636H13.2005V28.6448C13.2005 29.2438 13.0726 29.7646 12.8169 30.2073C12.5636 30.65 12.2132 30.9933 11.7658 31.2372C11.3207 31.4786 10.8094 31.5994 10.2317 31.5994C9.58777 31.5994 9.02196 31.4479 8.53427 31.1448C8.04895 30.8418 7.67016 30.4109 7.3979 29.8522C7.12802 29.2935 6.99308 28.6306 6.99308 27.8636C6.99308 27.2883 7.07002 26.771 7.2239 26.3117C7.38015 25.8501 7.60032 25.4571 7.88441 25.1328C8.1685 24.8084 8.50468 24.5598 8.89293 24.387C9.28119 24.2142 9.70851 24.1278 10.1749 24.1278C10.5584 24.1278 10.9159 24.1858 11.2473 24.3018C11.5811 24.4154 11.8783 24.5776 12.1387 24.7883C12.4015 24.9966 12.6204 25.2464 12.7956 25.5376C12.9708 25.8264 13.0916 26.1472 13.1578 26.4999H12.2488ZM14.7088 31.4999V24.2272H17.2514C17.758 24.2272 18.1759 24.3148 18.505 24.49C18.834 24.6628 19.0791 24.896 19.2401 25.1896C19.401 25.4808 19.4815 25.8039 19.4815 26.159C19.4815 26.4715 19.4259 26.7296 19.3146 26.9332C19.2057 27.1368 19.0613 27.2978 18.8814 27.4161C18.7038 27.5345 18.5109 27.6221 18.3026 27.6789V27.7499C18.5251 27.7641 18.7488 27.8423 18.9737 27.9843C19.1986 28.1264 19.3868 28.33 19.5384 28.5951C19.6899 28.8603 19.7656 29.1846 19.7656 29.5681C19.7656 29.9327 19.6828 30.2606 19.517 30.5518C19.3513 30.843 19.0897 31.0738 18.7322 31.2443C18.3748 31.4147 17.9096 31.4999 17.3366 31.4999H14.7088ZM15.5895 30.7187H17.3366C17.9119 30.7187 18.3203 30.6074 18.5618 30.3849C18.8056 30.16 18.9276 29.8877 18.9276 29.5681C18.9276 29.3219 18.8648 29.0946 18.7393 28.8863C18.6139 28.6756 18.4351 28.5075 18.2031 28.382C17.9711 28.2542 17.6965 28.1903 17.3793 28.1903H15.5895V30.7187ZM15.5895 27.4232H17.223C17.4882 27.4232 17.7273 27.3712 17.9403 27.267C18.1558 27.1628 18.3262 27.016 18.4517 26.8266C18.5795 26.6372 18.6435 26.4147 18.6435 26.159C18.6435 25.8394 18.5322 25.5684 18.3097 25.3458C18.0871 25.1209 17.7344 25.0085 17.2514 25.0085H15.5895V27.4232Z" fill="currentColor"/> </svg>';

export default class ModelExplorer {
  constructor() {
    this.selector = '.b-model-explorer';
    this.block = document.querySelector(this.selector);

    this.selectors = {
      data: '.b-model-explorer__data',
      tableHeaderCell: '.b-model-explorer__data-table-header-cell',
      container: '.b-model-explorer__container',
      selectProcessor: '.b-model-explorer__filter-select-dom',
      slider: '.b-model-explorer__range-slider',
      sliderFrom: '.b-model-explorer__range-slider-input--from',
      sliderTo: '.b-model-explorer__range-slider-input--to',
      sliderFps: '.b-model-explorer__range-slider[data-name="fpsTreshold"]',
      sliderTextFrom: '.b-model-explorer__range-slider-text--from',
      sliderTextTo: '.b-model-explorer__range-slider-text--to',
      sliderCurrentFrom: '.b-model-explorer__range-slider-current--from',
      sliderCurrentTo: '.b-model-explorer__range-slider-current--to',
      sliderAccuracy:
        '.b-model-explorer__range-slider[data-name="accuracyTreshold"]',
      sliderInput: '.b-model-explorer__range-slider-input',
      select: '.b-model-explorer__filter-select-dom',
      selectTask: '.b-model-explorer__filter-select-dom--task',
      selectModel: '.b-model-explorer__filter-select-dom--model',
      radio: '.b-model-explorer__filter-radio',
      radioChecked: '.b-model-explorer__filter-radio :checked',
      resetFilter: '.b-model-explorer__filter-reset',
      formFilter: '.b-model-explorer__filter-panel--form',

      zoomIn: '.b-model-explorer__diagram-zoom-btn--in',
      zoomOut: '.b-model-explorer__diagram-zoom-btn--out',

      taskDescription: '.b-model-explorer__description',

      tablesBody: '.b-model-explorer__data-items',
      toTablesLink: '.b-model-explorer__diagram-right-header-link',
      canvas: '.b-model-explorer__diagram-right-chart',
      titleGraph: '.b-model-explorer__title--graph',
      tableRow: '.b-model-explorer__data-table tbody tr',
      tableRowNotHidden: '.b-model-explorer__data-table tbody tr:not(.b-model-explorer__data--hidden)',
    };

    this.classes = {
      dataTable: 'b-model-explorer__data-table',
      tableHeaderCell: 'b-model-explorer__data-table-header-cell',
      tableHeaderCellInputResolution:
        'b-model-explorer__data-table-header-cell--input-resolution',
      tableHeaderCellTask: 'b-model-explorer__data-table-header-cell--task',
      data: 'b-model-explorer__data',
      dataHidden: 'b-model-explorer__data--hidden',
      title: 'b-model-explorer__title',
      titleTable: 'b-model-explorer__title--table',
      isSelected: 'is-selected',
    };

    this.fieldsOrder = [
      'networkName',
      'task',
      'input_resolution',
      'operations',
      'parameters',
      'license_name',
      'full_precision_accuracy',
      'post_quantization_accuracy',
      'fpsBatchSize1',
      'fpsBatchSize8',
      'retrainDocker',
      'source',
      'pretrained',
      'compiled',
      'parameters_i',
      'operations_i',
    ];

    this.fieldsGroupStart = [ 'full_precision_accuracy', 'fpsBatchSize1', 'retrainDocker', 'source' ];

    this.database = window.MODEL_EXPLORER_FILE || {};

    this.initialTablesRender = true;
  }

  bootstrap() {
    const container = this.block.querySelector(this.selectors.container);

    this.translations = JSON.parse(container.dataset.translations) || {};
    this.tooltips = JSON.parse(container.dataset.tooltips) || {};

    const selectProcessor = this.block.querySelector(
      this.selectors.selectProcessor,
    );

    selectProcessor.addEventListener('change', async () =>
      this.processorChanged(),);

    const radios = [ ...this.block.querySelectorAll(this.selectors.radio) ];

    radios.forEach(radio => {
      radio.addEventListener('change', () => {
        this.filterChanged();
      });
    });

    const selectTask = this.block.querySelector(this.selectors.selectTask);

    selectTask.addEventListener('change', () => this.taskChanged());

    const selectModel = this.block.querySelector(this.selectors.selectModel);

    selectModel.addEventListener('change', () => this.filterChanged());

    const sliders = [ ...this.block.querySelectorAll(this.selectors.slider) ];

    sliders.forEach(slider => {
      const sliderInputs = [
        ...slider.querySelectorAll(this.selectors.sliderInput),
      ];

      sliderInputs.forEach(sliderInput => {
        sliderInput.addEventListener('input', () => {
          const values = sliderInputs.map(input => parseInt(input.value, 10));

          const from = Math.min(...values);
          const to = Math.max(...values);

          this.setSliderValues(slider, from, to);
        });
        sliderInput.addEventListener('change', () => {
          const values = sliderInputs.map(input => parseInt(input.value, 10));

          const from = Math.min(...values);
          const to = Math.max(...values);

          this.setSliderValues(slider, from, to);

          slider.dispatchEvent(
            new CustomEvent('slider-change', { detail: slider.dataset }),
          );
        });
      });
    });

    sliders.forEach(slider => {
      slider.addEventListener('slider-change', () => this.filterChanged());
    });

    const formFilter = this.block.querySelector(this.selectors.formFilter);

    formFilter.addEventListener('reset', () =>
      setTimeout(() => this.taskChanged(), 0),);

    const toTablesLink = this.block.querySelector(this.selectors.toTablesLink);

    toTablesLink.addEventListener('click', event => {
      const tablesBody = this.block.querySelector(this.selectors.tablesBody);

      tablesBody.scrollIntoView({ behavior: 'smooth' });
      event.preventDefault();
    });

    this.initCanvas();

    this.processorChanged();

    this.handleTooltipVisibility();
  }

  handleTooltipVisibility() {
    let hideTimeout;

    // Add event listener to hide the tooltip when the mouse is not over it
    document.addEventListener('mousemove', event => {
      const tooltipEl = document.querySelector('.b-model-explorer__tooltip');

      if (tooltipEl) {
        const isMouseOver = isMouseOverElement(tooltipEl, event);

        if (!isMouseOver && tooltipEl.dataset.canBeClosed === 'true') {
          // Clear existing timeout if any
          clearTimeout(hideTimeout);

          // Introduce a delay before hiding the tooltip
          hideTimeout = setTimeout(() => {
            tooltipEl.style.opacity = 0;
            tooltipEl.style.visibility = 'hidden';
          }, 50);
        } else {
          // Clear the timeout if the mouse is back over the tooltip
          clearTimeout(hideTimeout);
        }
      }
    });
  }

  initCanvas() {
    const canvas = this.block.querySelector(this.selectors.canvas);

    const resizeChart = () => {
      canvas.width = canvas.parentNode.offsetWidth;
      canvas.height = canvas.parentNode.offsetHeight;
    };

    window.addEventListener('resize', resizeChart);
    resizeChart();

    const chart = new Chart(canvas, {
      type: 'line',
      data: {
        datasets: [
          {
            type: 'bubble',
            label: this.getTranslation('original_text'),
            data: [],
            order: 2,
            backgroundColor: '#7FC3FD',
            hoverBorderColor: '#142E6A',
            hoverBorderWidth: 3,
          },
          {
            type: 'bubble',
            label: this.getTranslation('quantized_text'),
            data: [],
            backgroundColor: '#A455D1',
          },
          {
            type: 'line',
            label: '',
            hidden: true,
            order: 1,
            data: [],
            borderWidth: 1,
            fill: false,
            borderColor: '#A455D1',
            pointRadius: 0,
            pointStyle: 'none',
          },
          {
            type: 'bubble',
            label: this.getTranslation('quantized_text'),
            data: [],
            datalabels: {
              labels: {
                title: null,
              },
            },
            backgroundColor: '#A455D1',
          },
        ],
      },

      options: {
        elements: {
          line: {
            tension: 0,
          },
        },
        animation: false,
        scales: {
          x: {
            type: 'logarithmic',
            position: 'bottom',
            stacked: true,
            offset: true,
            title: {
              display: true,
              text: this.getTranslation('fps_axis_label'),
            },
            ticks: {
              autoSkip: false,
              maxRotation: 45,
              minRotation: 45,
            },
            weight: 100,
          },
          y: {
            type: 'linear',
            position: 'left',
            offset: true,
            title: {
              display: true,
              text: this.getTranslation('accuracy_axis_label'),
            },
          },
        },

        plugins: {
          datalabels: {
            clip: true,
            clamp: true,
            anchor() {
              return 'end';
            },
            display() {
              return 'true';
            },
            align() {
              return 'top';
            },
            color() {
              return 'black';
            },
            font: {
              weight: 'bold',
              size: 8,
            },
            formatter: this.labelFormatter.bind(this),
            offset: 2,
            padding: 0,
          },
          tooltip: {
            enabled: false,
            position: 'nearest',
            external: this.externalTooltipHandler.bind(this),
          },
          legend: {
            display: false,
          },
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
                speed: 0.05,
                modifierKey: 'ctrl',
              },
              mode: 'xy',
            },
            pan: {
              enabled: true,
              mode: 'xy',
              speed: 0.5,
            },

            // Limits: {
            //   x: { min: 'original', max: 'original', minRange: 1 },
            //   y: { min: 'original', max: 'original', minRange: 1 },
            // },
          },
        },
        maintainAspectRatio: false,
        responsive: true,

        onHover(event) {
          const points = this.getElementsAtEventForMode(
            event,
            'index',
            { axis: 'x', intersect: true },
            false
          );

          if (points.length > 0) {
            event.native.target.style.cursor = 'pointer'; // eslint-disable-line no-param-reassign
          } else {
            event.native.target.style.cursor = 'default'; // eslint-disable-line no-param-reassign
          }
        },
      },
    });

    const zoomIn = this.block.querySelector(this.selectors.zoomIn);
    const zoomOut = this.block.querySelector(this.selectors.zoomOut);

    zoomIn.addEventListener('click', () => {
      chart.zoom(1.15, 'zoom');
    });
    zoomOut.addEventListener('click', () => {
      // Chart.resetZoom();
      chart.zoom(1 / 1.15, 'zoom');
    });

    this.chart = chart;
  }

  toTitleCase(phrase) {
    return (phrase || '')
      .toString()
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  labelFormatter(value, context) {
    const thisChart = context.chart;
    const isHidden = thisChart.getDatasetMeta(context.datasetIndex).data[
      context.dataIndex
    ].hidden;

    if (isHidden) {
      return '';
    }

    return this.toTitleCase(value.v);
  }

  tooltipTitle(context) {
    if (context.length > 0) {
      return this.toTitleCase(context[0].raw.infoData.networkName) || '';
    }
  }

  tooltipLabel(context) {
    return context.dataset.accuracyY === 'all' ?
      '' :
      this.toTitleCase(context.dataset.label) || '';
  }

  tooltipAfterLabel(context) {
    let info = '';

    const columns = this.getColumns();
    const columnsKeys = Object.keys(columns);

    const data = context.raw.infoData;

    columnsKeys.forEach(columnsKey => {
      let value = data[columnsKey];

      if (columnsKey === 'task') {
        return;
      }
      if (columnsKey === 'retrainDocker') {
        value = value ?
          this.getTranslation('yes_text') :
          this.getTranslation('no_text');
      }

      value = typeof value === 'number' ? value.toFixed(2) : value;

      info += `${columns[columnsKey]}: ${value}\n`;
    });

    return info;
  }

  async processorChanged() {
    const { file, task: oldValue } = await this.getState() || {};

    if (!file) {
      return;
    }

    const tablesBody = this.block.querySelector(this.selectors.tablesBody);

    tablesBody.innerHTML = '';

    const selectTask = this.block.querySelector(this.selectors.selectTask);

    if (selectTask) {
      selectTask.innerHTML = '';

      file.forEach(task => {
        const option = document.createElement('option');

        option.value = task.taskName;
        option.innerHTML = task.taskName;
        selectTask.append(option);
      });

      if (oldValue) {
        selectTask.value = oldValue;
      }

      if (!selectTask.value) {
        selectTask.selectedIndex = 0;
      }
    }

    this.initialTablesRender = true;

    this.taskChanged();
  }

  async taskChanged() {
    const { fileId, task, model, taskData } = await this.getState();

    const key = [ fileId, task ].join(',');

    const selectModel = this.block.querySelector(this.selectors.selectModel);

    // Update model select
    if (selectModel && task && key !== selectModel.dataset.forData) {
      const tasks = taskData;

      if (this.choices) {
        this.choices.destroy();
      }

      selectModel.innerHTML = '';

      if (tasks && tasks.items) {
        tasks.items
          .map(taskItem => taskItem.networkName)
          .forEach(networkName => {
            const option = document.createElement('option');

            option.value = networkName;
            option.innerHTML = networkName;
            selectModel.append(option);
          });
      }

      [ ...selectModel.options ].forEach(option => {
        option.selected = model.includes(option.value); // eslint-disable-line no-param-reassign
      });

      this.choices = new CustomChoices(selectModel, {
        itemSelectText: '',
        noResultsText: selectModel.dataset.noResultsText,
        noChoicesText: selectModel.dataset.noResultsText,
        placeholder: true,
        placeholderValue: selectModel.dataset.modelNamePlaceholderText,
        searchResultLimit: 10,
        renderChoiceLimit: -1,
        renderSelectedChoices: 'always',

        callbackOnCreateTemplates: () => ({
          dropdown: options => {
            const div = document.createElement('div');

            div.classList.add(options.classNames.list, options.classNames.listDropdown);
            div.setAttribute('aria-expanded', 'false');

            const selectAll = Object.assign(document.createElement('a'), { className: 'choices__select-all choices__item choices__item--selectable ', textContent: 'Select all', href: '#' });

            div.appendChild(selectAll);

            // Add click event listener
            selectAll.addEventListener('click', event => {
              event.preventDefault();

              // Toggle the state (add/remove a class, change text, or any other desired action)
              if (selectAll.classList.contains(this.classes.isSelected)) {
                selectAll.classList.remove(this.classes.isSelected);

                this.choices.removeActiveItems();
                this.filterChanged();

                // Perform additional actions for deselecting if needed
              } else {
                selectAll.classList.add(this.classes.isSelected);

                // Perform additional actions for selecting if needed
                const currentState = this.choices.getCurrentState();

                if (currentState.choices) {
                  [ ...currentState.choices ].forEach(choice => {
                    if (this.choices.input.element.value.length > 0) {
                      if (choice.score < 0.01) {
                        this.choices.setChoiceByValue(choice.value);
                      }
                    } else {
                      this.choices.setChoiceByValue(choice.value);
                    }
                  });
                }

                this.filterChanged();
              }
            });

            return div;
          },
        }),
      });

      selectModel.addEventListener('highlightItem', event => {
        this.choices.removeActiveItemsByValue(event.detail.value);
        this.filterChanged();
      });

      selectModel.dataset.forData = key;
    }

    // Calculate min/max values for sliders
    const tableData = taskData.items.reduce(
      (acc, item) => {
        acc.fpsSet.push(item.fpsBatchSize1);
        acc.accuracySet.push(item.full_precision_accuracy);
        acc.accuracySet.push(item.post_quantization_accuracy);

        return acc;
      },
      { fpsSet: [], accuracySet: []},
    );

    const { fpsSetMin, fpsSetMax } = this.calculateFpsSliderMinMax(tableData);

    const accuracySetMin = Math.floor(Math.min(...tableData.accuracySet));
    const accuracySetMax = Math.ceil(Math.max(...tableData.accuracySet));

    const sliderFps = this.block.querySelector(this.selectors.sliderFps);

    this.setSliderLimits(sliderFps, fpsSetMin, fpsSetMax);

    const sliderAccuracy = this.block.querySelector(
      this.selectors.sliderAccuracy,
    );

    this.setSliderLimits(sliderAccuracy, accuracySetMin, accuracySetMax);

    this.filterChanged().then(() => {
      this.initialTablesRender = false;
    });
  }

  calculateFpsSliderMinMax(tableData) {
    let fpsSetMin =
      Math.round(Math.floor(Math.min(...tableData.fpsSet)) / 100) * 100;
    let fpsSetMax =
      Math.round(Math.ceil(Math.max(...tableData.fpsSet)) / 100) * 100;

    fpsSetMax += fpsSetMax > 3800 ? 800 : 200;
    fpsSetMin -= 50;

    if (fpsSetMin < 0) {
      fpsSetMin = 0;
    }

    return {
      fpsSetMin, fpsSetMax,
    };
  }

  scaleValue(value, paramsArrMin, paramsArrMax, newMin, newMax) {
    return (
      ((value - paramsArrMin) / (paramsArrMax - paramsArrMin)) * // eslint-disable-line no-mixed-operators
        (newMax - newMin) + // eslint-disable-line no-mixed-operators
      newMin
    );
  }

  setSliderValues(slider, from, to) {
    const sliderFrom = slider.querySelector(this.selectors.sliderFrom);

    sliderFrom.value = from;

    const sliderTo = slider.querySelector(this.selectors.sliderTo);

    sliderTo.value = to;

    slider.dataset.from = from; // eslint-disable-line no-param-reassign
    slider.dataset.to = to; // eslint-disable-line no-param-reassign

    const sliderCurrentFrom = slider.querySelector(
      this.selectors.sliderCurrentFrom,
    );

    sliderCurrentFrom.innerHTML = slider.dataset.from;

    const sliderCurrentTo = slider.querySelector(
      this.selectors.sliderCurrentTo,
    );

    sliderCurrentTo.innerHTML = slider.dataset.to;
  }

  setSliderLimits(slider, from, to) {
    const sliderFrom = slider.querySelector(this.selectors.sliderFrom);

    sliderFrom.setAttribute('min', from);
    sliderFrom.setAttribute('max', to);

    const sliderTo = slider.querySelector(this.selectors.sliderTo);

    sliderTo.setAttribute('min', from);
    sliderTo.setAttribute('max', to);

    const sliderTextFrom = slider.querySelector(this.selectors.sliderTextFrom);

    sliderTextFrom.innerHTML = from;

    const sliderTextTo = slider.querySelector(this.selectors.sliderTextTo);

    sliderTextTo.innerHTML = to;

    this.setSliderValues(slider, from, to);
  }

  async getState() {
    const data = {};

    const selectProcessor = this.block.querySelector(
      this.selectors.selectProcessor,
    );

    data.fileId = selectProcessor.value;

    const selects = [ ...this.block.querySelectorAll(this.selectors.select) ];

    selects.forEach(select => {
      if (select.multiple) {
        data[select.name] = [ ...select.selectedOptions ].map(
          option => option.value,
        );
      } else {
        data[select.name] = select.value;
        data[`${select.name}Index`] = select.selectedIndex;
      }
    });

    const sliders = [ ...this.block.querySelectorAll(this.selectors.slider) ];

    sliders.forEach(slider => {
      const { name, from, to } = slider.dataset;

      data[name] = {
        from: parseInt(from, 10),
        to: parseInt(to, 10),
      };
    });

    const radios = [ ...this.block.querySelectorAll(this.selectors.radio) ];

    radios.forEach(radio => {
      if (radio.checked) {
        data[radio.name] = radio.value;
      }
    });

    data.file = await this.getData(data.fileId);
    data.taskData = data.file.find(task => task.taskName === data.task);

    return data;
  }

  async filterChanged() {
    const state = await this.getState();

    this.updatePage(state);
  }

  updatePage(state) {
    this.updateTexts(state);

    if (state.taskIndex > 0) {
      const taskTables = [ ...this.block.querySelectorAll(this.selectors.data) ];

      taskTables.forEach(taskTable =>
        taskTable.classList.add(this.classes.dataHidden));

      this.renderTable(state.task, state.taskData, state);
    } else {
      state.file.forEach(task => {
        this.renderTable(task.taskName, task, state);
      });
    }

    // This.renderTable(state.task, state.taskData);
    this.renderGraph(state, state.taskData);
  }

  renderGraph(state, taskData) {
    const [ datasetOriginal, datasetQuantized, datasetAllLines, datasetAll ] =
      this.chart.data.datasets;
    const { data: dataOriginal } = datasetOriginal;
    const { data: dataQuantized } = datasetQuantized;

    datasetAllLines.data = [];
    const { data: dataAllLines } = datasetAllLines;
    const { data: dataAll } = datasetAll;

    const allData = taskData.items;

    const {
      docker: dockerFilter,
      model: modelFilter,
      accuracyTreshold: accuracyTresholdFilter,
      fpsTreshold: fpsTresholdFilter,
      batch_size: batchSize,
    } = state;

    const filteredData = allData
      .filter(({ retrainDocker }) => {
        if (dockerFilter === 'all') {
          return true;
        }

        return retrainDocker === (dockerFilter === 'yes');
      })
      .filter(
        ({ networkName }) =>
          !modelFilter.length || modelFilter.includes(networkName),
      )
      .filter(
        item =>
          item[`fpsBatchSize${batchSize}`] >= fpsTresholdFilter.from &&
          fpsTresholdFilter.to >= item[`fpsBatchSize${batchSize}`],
      );

    datasetOriginal.accuracyY = state.accuracy_y;
    datasetQuantized.accuracyY = state.accuracy_y;
    datasetAll.accuracyY = state.accuracy_y;

    datasetOriginal.hidden = state.accuracy_y === 'poa';
    datasetQuantized.hidden = state.accuracy_y !== 'poa';
    datasetAllLines.hidden = state.accuracy_y !== 'all';
    datasetAll.hidden = state.accuracy_y !== 'all';

    const paramsArrMax = taskData.parameters_max;
    const paramsArrMin = taskData.parameters_min;

    const foundOriginalIds = [];
    const foundQuantizedIds = [];
    const foundAllIds = [];

    filteredData.forEach(item => {
      const dotData = {
        // X: item[`fpsBatchSize${batchSize}`],
        x: item[`fpsBatchSize${batchSize}`],
        // eslint-disable-next-line id-length
        r: this.scaleValue(
          item.parameters_i,
          paramsArrMin,
          paramsArrMax,
          5,
          20,
        ),
        v: item.networkName, // eslint-disable-line id-length
        infoData: item,
      };

      let y = item.full_precision_accuracy;

      if (accuracyTresholdFilter.from <= y && accuracyTresholdFilter.to >= y) {
        const indexOriginal = dataOriginal.findIndex(
          ({ infoData }) => infoData === item,
        );

        if (indexOriginal >= 0) {
          // Update x prop, since Batch size might be changed.
          dataOriginal[indexOriginal].x = dotData.x;

          foundOriginalIds.push(indexOriginal);
        } else {
          dataOriginal.push({
            ...dotData,
            y,
          });

          foundOriginalIds.push(dataOriginal.length - 1);
        }
      }

      y = item.post_quantization_accuracy;
      if (accuracyTresholdFilter.from <= y && accuracyTresholdFilter.to >= y) {
        const indexQuantized = dataQuantized.findIndex(
          ({ infoData }) => infoData === item,
        );

        if (indexQuantized >= 0) {
          // Update x prop, since Batch size might be changed.
          dataQuantized[indexQuantized].x = dotData.x;
          foundQuantizedIds.push(indexQuantized);
        } else {
          dataQuantized.push({
            ...dotData,
            y,
          });

          foundQuantizedIds.push(dataQuantized.length - 1);
        }
      }

      if (accuracyTresholdFilter.from <= y && accuracyTresholdFilter.to >= y) {
        dataAllLines.push({
          x: item[`fpsBatchSize${batchSize}`],
          y: item.post_quantization_accuracy,
        });
        dataAllLines.push({
          x: item[`fpsBatchSize${batchSize}`],
          y: item.full_precision_accuracy,
        });
        dataAllLines.push({
          x: null,
          y: null,
        });

        const indexAll = dataAll.findIndex(({ infoData }) => infoData === item);

        if (indexAll >= 0) {
          dataAll[indexAll].x = dotData.x;
          foundAllIds.push(indexAll);
        } else {
          dataAll.push({
            ...dotData,
            // eslint-disable-next-line id-length
            r: 3,
            y,
          });

          foundAllIds.push(dataAll.length - 1);
        }
      }
    });

    dataOriginal
      .map((item, index) => (!foundOriginalIds.includes(index) ? index : false))
      .filter(index => index !== false)
      .reverse()
      .forEach(index => dataOriginal.splice(index, 1));

    dataQuantized
      .map((item, index) =>
        !foundQuantizedIds.includes(index) ? index : false,)
      .filter(index => index !== false)
      .reverse()
      .forEach(index => dataQuantized.splice(index, 1));

    dataAll
      .map((item, index) => (!foundAllIds.includes(index) ? index : false))
      .filter(index => index !== false)
      .reverse()
      .forEach(index => dataAll.splice(index, 1));

    if (dataAll.length === 1 && state.accuracy_y === 'all') {
      const offsetMinMax = 2;

      this.chart.options.scales.y.suggestedMin = dataAll[0].infoData.post_quantization_accuracy - offsetMinMax;
      this.chart.options.scales.y.suggestedMax = dataAll[0].infoData.full_precision_accuracy + offsetMinMax;
    } else {
      // We ca override the suggestedMin, suggestedMax values if needed
    }

    this.chart.resetZoom();
    this.chart.update();
  }

  updateTexts(state) {
    const graphTitle = this.block.querySelector(this.selectors.titleGraph);

    graphTitle.innerHTML = `${graphTitle.dataset.prefix}: ${state.task}`;

    const taskDescription = this.block.querySelector(
      this.selectors.taskDescription,
    );

    taskDescription.innerHTML = '';

    const descriptionsData = this.getTranslation('task_description_matchers');

    const descriptionData = descriptionsData.find(description =>
      state.task.toLowerCase().includes(description.includes_string),);

    if (descriptionData) {
      taskDescription.innerHTML = descriptionData.text;
    }
  }

  getColumns() {
    const tableColumns = this.getTranslation('table_columns');

    return tableColumns.reduce((acc, item) => {
      acc[item.field] = item.title; // eslint-disable-line no-param-reassign

      return acc;
    }, {});
  }

  getTranslation(key) {
    return this.translations[key] || key;
  }

  renderTable(taskName, tableData, state) {
    const currentTaskTable = this.block.querySelector(
      `${this.selectors.data}[data-task-name="${taskName}"]`,
    );

    const {
      docker: dockerFilter,
      model: modelFilter,
      accuracyTreshold: accuracyTresholdFilter,
      fpsTreshold: fpsTresholdFilter,
    } = state;

    const rows = this.block.querySelectorAll(this.selectors.tableRow);

    // Run throught all rows and hide the ones that don't pass the filters
    // var rowPostQuantizationAccuracy = row.querySelector('td[data-key="post_quantization_accuracy"]').dataset.value;
    // var rowFpsBatchSize8 = row.querySelector('td[data-key="fpsBatchSize8"]').dataset.value;

    if (!this.initialTablesRender) {
      [ ...rows ].forEach(row => {
        const rowFullPrecisionAccuracy = parseFloat(row.querySelector('td[data-key="full_precision_accuracy"]').dataset.value);
        const rowFpsBatchSize1 = parseFloat(row.querySelector('td[data-key="fpsBatchSize1"]').dataset.value);
        const rowRetrainDocker = row.querySelector('td[data-key="retrainDocker"]').dataset.value.toLowerCase() === 'true';
        const rowModelName = row.querySelector('td[data-key="networkName"]').dataset.value;

        // Check if the row passes the filters
        if (
          (
            (dockerFilter === 'all') ||
            (dockerFilter === 'yes' && rowRetrainDocker) ||
            (dockerFilter === 'no' && !rowRetrainDocker)
          ) &&
          (!modelFilter.length > 0 || modelFilter.includes(rowModelName)) &&
          (
            !accuracyTresholdFilter ||
            (rowFullPrecisionAccuracy >= accuracyTresholdFilter.from && rowFullPrecisionAccuracy <= accuracyTresholdFilter.to)
          ) &&
          (
            !fpsTresholdFilter ||
            (rowFpsBatchSize1 >= fpsTresholdFilter.from && rowFpsBatchSize1 <= fpsTresholdFilter.to)
          )
        ) {
          // If the row passes all filters, display it
          row.classList.remove(this.classes.dataHidden);
        } else {
          // If the row doesn't pass all filters, hide it
          row.classList.add(this.classes.dataHidden);
        }
      });
    }

    if (currentTaskTable) {
      const currentTaskTableRows = currentTaskTable.querySelectorAll(this.selectors.tableRowNotHidden);

      if (currentTaskTableRows.length > 0) {
        currentTaskTable.classList.remove(this.classes.dataHidden);
      } else {
        currentTaskTable.classList.add(this.classes.dataHidden);
      }

      return;
    }

    const tablesBody = this.block.querySelector(this.selectors.tablesBody);

    const task = document.createElement('div');
    const container = document.createElement('div');
    const h3 = document.createElement('h3');

    task.dataset.taskName = taskName;
    task.classList.add(this.classes.data);
    container.classList.add('container');
    h3.classList.add(this.classes.title);
    h3.classList.add(this.classes.titleTable);

    const table = document.createElement('table');

    table.classList.add(this.classes.dataTable);

    h3.innerHTML = `${this.getTranslation('title_prefix')}: ${taskName}`;

    task.append(container);
    container.append(h3);
    container.append(table);
    tablesBody.append(task);

    const columns = this.getColumns();

    const columnsKeys = Object.keys(columns);

    // Filter out known keys and sort the remaining keys
    const unknownKeys = columnsKeys.filter(key => !this.fieldsOrder.includes(key)).sort();

    // Concatenate known and unknown keys to get the final order
    const finalOrder = this.fieldsOrder.concat(unknownKeys);

    const fieldsToSkip = [ 'task', 'parameters_i', 'operations_i' ];

    const thead = document.createElement('thead');
    const trHead = document.createElement('tr');

    for (const key of finalOrder) {
      if (fieldsToSkip.includes(key)) {
        continue;
      }
      const th = document.createElement('th');

      th.classList.add(this.classes.tableHeaderCell);
      th.dataset.direction = 'asc';

      if (this.fieldsGroupStart.includes(key)) {
        th.classList.add('--group-start');
      }

      th.innerHTML = columns[key] || key;

      const columnTooltip = findTooltipByColumn(key, this.tooltips);

      if (columnTooltip) {
        const tooltipeElement = document.createElement('span');

        tooltipeElement.classList.add('b-model-explorer__data-table-tooltip');
        tooltipeElement.dataset.bsTitle = columnTooltip;
        tooltipeElement.dataset.bsToggle = 'tooltip';

        if (key === 'compiled') {
          const hasNV12Link = hasNonEmptyCompiledNV12(tableData.items);

          if (hasNV12Link) {
            th.appendChild(tooltipeElement);
            new Tooltip(tooltipeElement); // eslint-disable-line no-new
            th.classList.add('--has-tooltip');
          }
        } else {
          th.appendChild(tooltipeElement);
          new Tooltip(tooltipeElement); // eslint-disable-line no-new
          th.classList.add('--has-tooltip');
        }
      }

      trHead.append(th);
    }

    thead.append(trHead);
    table.append(thead);

    const tbody = document.createElement('tbody');

    tableData.items.forEach(item => {
      const tr = document.createElement('tr');

      for (const column of finalOrder) {
        if (fieldsToSkip.includes(column)) {
          continue;
        }

        const td = document.createElement('td');

        let value = item[column];
        let sortValue = value;

        if (column === 'parameters') {
          sortValue = item.parameters_i;
        } else if (column === 'operations') {
          sortValue = item.operations_i;
        }

        td.dataset.value = sortValue;
        td.dataset.key = column;

        if (column === 'task') {
          value = taskName;
        } else if (column === 'retrainDocker') {
          value = value ?
            this.getTranslation('yes_text') :
            this.getTranslation('no_text');
        }

        if (isValidURL(value)) {
          if (isFileURL(value)) {
            value = `<a download="${value}" href="${value}">${iconDownload}</a>`;
          } else {
            value = `<a target="_blank" href="${value}">${iconLink}</a>`;
          }
        }

        // Combine links for the compiled field
        if (column === 'compiled') {
          if (typeof item.compiled_nv12 !== 'undefined' && item.compiled_nv12) {
            if (typeof item.compiled !== 'undefined' && item.compiled) {
              value = `<a class="link--rgb" download="${item.compiled}" href="${item.compiled}">${iconDownloadRgb}</a>`;
            }

            value += `<a class="link--n12" download="${item.compiled_nv12}" href="${item.compiled_nv12}">${typeof item.compiled !== 'undefined' && item.compiled ? iconDownloadNV12 : iconDownload}</a>`;
          }
        }

        if (this.fieldsGroupStart.includes(column)) {
          td.classList.add('--group-start');
        }

        td.innerHTML = typeof value === 'number' ? value.toFixed(2) : value;
        tr.append(td);
      }

      tbody.append(tr);
    });

    table.append(tbody);

    const headerCells = [
      ...table.querySelectorAll(this.selectors.tableHeaderCell),
    ];

    headerCells.forEach((headerCell, idx) => {
      headerCell.addEventListener('click', () => {
        const isAsc = headerCell.dataset.direction === 'asc';

        headerCell.dataset.direction = isAsc ? 'desc' : 'asc'; // eslint-disable-line no-param-reassign

        [ ...table.querySelectorAll('tbody tr') ]
          .sort(this.comparer(idx, !isAsc))
          .forEach(tr => tbody.appendChild(tr));
      });
    });
  }

  comparer(idx, asc) {
    return (aItem, bItem) =>
      ((v1, v2) =>
        v1 !== '' && v2 !== '' && !isNaN(v1) && !isNaN(v2) ?
          v1 - v2 :
          v1.toString().localeCompare(v2))(
        this.getCellValue(asc ? aItem : bItem, idx),
        this.getCellValue(asc ? bItem : aItem, idx),
      );
  }

  getCellValue(tr, idx) {
    const node = tr.children[idx];

    return node.dataset.value;
  }

  async getData(fileId) {
    if (this.database[fileId]) {
      return this.database[fileId];
    }

    return await this.fetchFile(fileId);
  }

  async fetchFile(fileId) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();

      const option = this.block.querySelector(`option[value="${fileId}"]`);

      if (!option) {
        reject(new Error('no nonce'));
      }

      formData.append('action', 'get_explorer_json');
      formData.append('file_id', fileId);
      formData.append('nonce', option.dataset.nonce);

      fetch(window.af_app.ajaxurl, {
        method: 'POST',
        body: formData,
      })
        .then(result => result.json())
        .then(data => {
          this.database[fileId] = data;
          resolve(data);
        })
        .catch(reject);
    });
  }

  tooltipValue(key, val) { // eslint-disable-next-line no-unused-vars
    let value = val;

    if (key === 'retrainDocker') {
      value = value ?
        this.getTranslation('yes_text') :
        this.getTranslation('no_text');
    }

    value = typeof value === 'number' ? value.toFixed(2) : value;

    return value;
  }

  externalTooltipHandler(context) {
    // Tooltip Element
    let tooltipEl = document.querySelector('.b-model-explorer__tooltip');

    // Create element on first render
    if (!tooltipEl) {
      tooltipEl = document.createElement('div');
      tooltipEl.classList.add('b-model-explorer__tooltip');
      tooltipEl.innerHTML = '<table></table>';
      document.body.appendChild(tooltipEl);
    }

    const { chart } = context;

    // Hide if no tooltip
    const tooltipModel = context.tooltip;

    if (tooltipModel.opacity === 0) {
      // TooltipEl.style.opacity = 0;
      tooltipEl.dataset.canBeClosed = true;

      return;
    }
    tooltipEl.dataset.canBeClosed = false;

    // Set caret Position
    tooltipEl.classList.remove('above', 'below', 'no-transform');
    if (tooltipModel.yAlign) {
      tooltipEl.classList.add(tooltipModel.yAlign);
    } else {
      tooltipEl.classList.add('no-transform');
    }

    // Extract tooltip data
    const [{ datasetIndex, dataIndex }] = tooltipModel.dataPoints;
    const dataset = chart.data.datasets[datasetIndex];
    const value = dataset.data[dataIndex];
    const { infoData } = value;
    const columns = Object.assign(this.getColumns(), { task: 'Task' });
    const { r: pointRadius } = dataset.data[dataIndex]; // eslint-disable-line id-length
    const fieldsToSkip = [ 'networkName', 'parameters_i', 'operations_i', 'compiled_nv12', 'compiled_rgb' ];

    if (infoData) {
      const tableHead = document.createElement('thead');
      const tr = document.createElement('tr');
      const th = document.createElement('th');
      const text = document.createTextNode(this.toTitleCase(infoData.networkName));

      th.appendChild(text);
      tr.appendChild(th);
      tableHead.appendChild(tr);
      const tableBody = document.createElement('tbody');

      // Get all keys dynamically
      const allKeys = Object.keys(infoData);

      // Filter out known keys and sort the remaining keys
      const unknownKeys = allKeys.filter(key => !this.fieldsOrder.includes(key)).sort();

      // Concatenate known and unknown keys to get the final order
      const finalOrder = this.fieldsOrder.concat(unknownKeys);

      for (const key of finalOrder) {
        const value = infoData[key]; // eslint-disable-line no-shadow

        if (fieldsToSkip.includes(key)) {
          continue;
        }

        const row = tableBody.insertRow();
        const cell1 = row.insertCell(0);
        const cell2 = row.insertCell(1);
        let cell2InnerHtml = '';

        cell1.textContent = columns[key] || key;

        // Check if the key is in the list that requires the "space-break" class.
        if (this.fieldsGroupStart.includes(key)) {
          row.classList.add('--space-above');
        }

        if (isValidURL(value)) {
          if (isFileURL(value)) {
            cell2InnerHtml = `<a download="${value}" href="${value}">${iconDownload}</a>`;
          } else {
            cell2InnerHtml = `<a target="_blank" href="${value}">${iconLink}</a>`;
          }
        } else {
          cell2InnerHtml = this.tooltipValue(key, value);
        }

        // Set value for the Compiled field
        if (key === 'compiled') {
          if (typeof infoData.compiled_nv12 !== 'undefined' && infoData.compiled_nv12) {
            if (typeof infoData.compiled !== 'undefined' && infoData.compiled) {
              cell2InnerHtml = `<a class="link--rgb" download="${infoData.compiled}" href="${infoData.compiled}">${iconDownloadRgb}</a>`;
            }

            cell2InnerHtml += `<a class="link--n12" download="${infoData.compiled_nv12}" href="${infoData.compiled_nv12}">${typeof infoData.compiled !== 'undefined' && infoData.compiled ? iconDownloadNV12 : iconDownload}</a>`;
          }
        }

        cell2.innerHTML = cell2InnerHtml;
      }

      const tableRoot = tooltipEl.querySelector('table');

      // Remove old children
      while (tableRoot.firstChild) {
        tableRoot.firstChild.remove();
      }

      // Add new children
      tableRoot.appendChild(tableHead);
      tableRoot.appendChild(tableBody);
    }

    const position = context.chart.canvas.getBoundingClientRect();
    const chartWidth = context.chart.width;

    // Calculate the x-position of the tooltip based on the caretX coordinate
    let tooltipX = position.left + window.pageXOffset + tooltipModel.caretX;

    // Check if the tooltip is too close to the right edge
    const tooltipWidth = tooltipEl.offsetWidth < 500 ? tooltipEl.offsetWidth : tooltipModel.width;

    const distanceToRightEdge = chartWidth - tooltipX;

    const offset = 23;

    if (distanceToRightEdge < tooltipWidth) {
      // If too close to the right edge, position the tooltip to the left of the data point
      tooltipX -= tooltipWidth + pointRadius + offset;
      tooltipEl.dataset.position = 'left';
    } else {
      tooltipX += pointRadius + offset;
      tooltipEl.dataset.position = 'right';
    }

    // Display, position, and set styles for font
    tooltipEl.style.opacity = 1;
    tooltipEl.style.visibility = 'visible';
    tooltipEl.style.position = 'absolute';
    tooltipEl.style.left = `${tooltipX}px`;
    tooltipEl.style.top = `${position.top + window.pageYOffset + tooltipModel.caretY - 37}px`;
  }
}

